<template>
  <v-dialog persistent v-model="show">
    <v-toolbar>
      <v-toolbar-items>
        <v-btn @click="close" color="error" flat>
          <v-icon dark left>arrow_back</v-icon>返回
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :hide-actions="true"
          :items="pagination.content"
          :rows-per-page-items="[10]"
          :total-items="pagination.totalItems"
          class="elevation-1"
          v-model="selected"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.printDatetime }}</td>
            <td>{{ props.item.printByCode + ':' + props.item.fullName }}</td>
            <td>{{ props.item.companyName }}</td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ['history'],
  data() {
    return {
      show: false,
      selected: [],
      headers: [
        { text: '期日', value: 'printDatetime', sortable: false },
        { text: '担当', value: 'printByCode', sortable: false },
        { text: '所属', value: 'companyName', sortable: false },
      ],
      pagination: {
        rowsPerPage: 5,
        page: 1,
      },
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    close() {
      this.show = false
    },
  },
  watch: {
    history() {
      this.$pagination(this.history)
    },
  },
}
</script>
